import React from 'react';
import classnames from 'classnames';
import classes from './classes.module.scss';

const renderBadge = (count, visible, customClass) => (count > 0 && visible ? (
  <div className={ classnames(classes.badgeContainer, customClass) } />

) : null);

const renderBadgeAroundAComponent = (count, children, visible, customClass) => (
  <div className={ classes.container }>
    <div>{children}</div>
    {renderBadge(
      count,
      visible,
      classnames(classes.badgeContainerAsChild, customClass)
    )}
  </div>
);

function Badge({
  count,
  children,
  visible = true,
  customClass
}) {
  return children
    ? renderBadgeAroundAComponent(count, children, visible, customClass)
    : renderBadge(count, visible, customClass);
}

export default Badge;
